import React from "react";
import Breadcrumbs from "apollo-react/components/Breadcrumbs";
import { useTranslation } from "react-i18next";
import HouseIcon from "apollo-react-icons/House";
import MedicalCard from "apollo-react-icons/MedicalCard";
import Planner from "apollo-react-icons/Planner";
import PresentationHierarchyLight from "apollo-react-icons/PresentationHierarchyLight";
import StatusCheck from "apollo-react-icons/StatusCheck";
import Bell from "apollo-react-icons/Bell";
import FileAccountPlan from "apollo-react-icons/FileAccountPlan";
import { adminRoutesConfig, superAdminRoutesConfig, customerRoutesConfig } from "../../routesConfig";

const personaConfigs = {
  "admin": adminRoutesConfig,
  "super-admin": superAdminRoutesConfig,
  "end-user": customerRoutesConfig,
};

// Helper to find route config by path (supports params)
const findRouteByPath = (routes, path) => {
  return routes.find(route => {
    // Replace :params with regex wildcards
    const routePattern = route.path.replace(/:[^/]+/g, "[^/]+");
    const regex = new RegExp(`^${routePattern}$`);
    return regex.test(path);
  });
};

// Improved getPageName
export const getPageName = (source, location) => {
  const routes = personaConfigs[source] || [];
  const pathname = location.pathname;

  // Special logs handling
  if (/\/logs(\/|$)/.test(pathname)) {
    const subPageMatch = pathname.match(/^\/(admin|super-admin)\/[^/]+\/([^/]+)/);
    const subPageName = subPageMatch ? subPageMatch[2].replace(/-/g, " ") : "";
    if (subPageName === "log") return "Log Details";
    if (subPageName) return `audit logs - ${subPageName}`;
    return "logs";
  }

  // Try to find a matching route
  const matchedRoute = routes.find(route => {
    // Replace :params with regex wildcards
    const routePattern = route.path.replace(/:[^/]+/g, "[^/]+");
    const regex = new RegExp(`^${routePattern}$`);
    return regex.test(pathname);
  });

  return matchedRoute ? matchedRoute.title : "home";
};

export const pageIcons = {
  home: <HouseIcon style={{ fontSize: "36px", color: "#4D4D4D" }} />,
  users: <MedicalCard style={{ fontSize: "36px", color: "#4D4D4D" }} />,
  "end-users": <MedicalCard style={{ fontSize: "36px", color: "#4D4D4D" }} />,
  roles: <MedicalCard style={{ fontSize: "36px", color: "#4D4D4D" }} />,
  categories: <MedicalCard style={{ fontSize: "36px", color: "#4D4D4D" }} />,
  forms: <Planner style={{ fontSize: "36px", color: "#4D4D4D" }} />,
  subforms: <Planner style={{ fontSize: "36px", color: "#4D4D4D" }} />,
  workflows: <PresentationHierarchyLight style={{ fontSize: "36px", color: "#4D4D4D" }} />,
  approvals: <StatusCheck style={{ fontSize: "36px", color: "#4D4D4D" }} />,
  reminders: <Bell style={{ fontSize: "36px", color: "#4D4D4D" }} />,
  logs: <FileAccountPlan style={{ fontSize: "36px", color: "#4D4D4D" }} />,
};

const CommonBreadcrumbs = ({ source, pathnames, location }) => {
  const [t] = useTranslation();
  const routes = personaConfigs[source] || [];
  
  const searchParams = new URLSearchParams(location.search);
  const draftId = searchParams.get('draftId');

  let rootHref = "";
  if (source === "end-user") {
    rootHref = "/customer/home";
  } else {
    rootHref = `/${source}/home`;
  }

  const items = [{ title: <HouseIcon />, href: rootHref }];

  let currentPath = "";
  pathnames.forEach((name, index) => {
    currentPath += `/${name}`;

    if (!isNaN(Number(name))) return;

    const nextIsNumber = pathnames[index + 1] && !isNaN(Number(pathnames[index + 1]));
    if (findRouteByPath(routes, currentPath) || nextIsNumber) {
      if (!items.some(item => item.href === currentPath)) {
        let breadcrumbHref = currentPath;
        let breadcrumbTitle = t(name);
        
        if (name === "new-requests" && draftId && location.pathname.includes("/new-requests/view/")) {
          breadcrumbHref = "/customer/requests/my-requests";
          breadcrumbTitle = t("My_Requests");
        }
        
        items.push({ title: breadcrumbTitle, href: breadcrumbHref });
      }
    }
  });

  return (
    <Breadcrumbs
      items={items}
      className="capitalize"
      style={{
        padding: 0,
        color: "#999999",
        textDecoration: "none",
        marginBottom: "27px",
      }}
    />
  );
};

export default CommonBreadcrumbs;